import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a56dc34&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../../../assets/scss/typography.scss?vue&type=style&index=0&lang=scss&module=styleTypography&"
import style1 from "../../../assets/scss/grid.scss?vue&type=style&index=1&lang=scss&module=styleGrid&"
import style2 from "../../../assets/scss/spacer.scss?vue&type=style&index=2&lang=scss&module=styleSpacer&"
import style3 from "./index.vue?vue&type=style&index=3&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleTypography"] = (style0.locals || style0)
this["styleGrid"] = (style1.locals || style1)
this["styleSpacer"] = (style2.locals || style2)
this["$style"] = (style3.locals || style3)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports